const vo = {
  vo1: { name: 'Berechnen', desc: 'z.B. Steuerabgaben, Lohnkosten', },
  vo2: { name: 'Ordnen', desc: 'z.B. Papiere, Unterlagen, Informationen', },
  vo3: { name: 'Verwalten', desc: 'z.B. Personaldaten, Akten, Ordner', },
  vo4: { name: 'Regulieren', desc: 'z.B. Straßenverkehr, Abläufe', },
  vo5: { name: 'Schreiben', desc: 'z.B. Geschäftsbriefe, Abmahnungen, Rechnungen', },
  vo6: { name: 'Überwachen', desc: 'z.B. Gesetze, Regeln, Richtlinien', },
  vo7: { name: 'Sammeln', desc: 'z.B. Informationen, Personendaten', },
  vo8: { name: 'Beantragen', desc: 'z.B. Förderungen, Hilfsleistungen', },
  vo9: { name: 'Auswerten', desc: 'z.B. Statistiken, Erhebungen', },
  vo10: { name: 'Kontrollieren', desc: 'z.B. Vereinbarungen, Vorschriften', },
}

export default vo
